import { useAPI } from '@/composables';
import type { IQueryParams, VulnerabilityAPI } from '@/types';
import { params2Query } from '@/utils';

export const getVulnerabilitiesByResearcherId = (
  id: string,
  tab: string,
  query: IQueryParams
) => {
  const includeParams =
    tab === 'all'
      ? 'include[]=type&include[]=product.kind&include[]=versions&include[]=cvss'
      : 'include=reportedTempData';

  const url = tab === 'all' ? '' : `/${tab}`;
  const { page = 1, ...rest } = query;
  const params = params2Query(rest) || '';
  return useAPI<VulnerabilityAPI>(
    `/researchers/${id}/vulnerabilities${url}?${includeParams}&${params}`,
    {
      query: {
        page: page
      }
    }
  );
};
